<template>
  <div id="agencyAdd">
    <v-container grid-list-md text-xs-center>
      <v-layout wrap>
          <v-flex xs12 class="button-container pr-2 mb-5 text-xs-right">
            <v-btn fab absolute left href="#/agencies" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="d-inline-flex" v-if="selectedAgency">
              <v-btn class="pf-btn pf-btn-cancel" to="/agencies">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="saveRequest">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Request</div>
              </v-btn>
            </div>
          </v-flex>
      </v-layout>
      <v-layout wrap row>
        <app-stepper :itemList="stepperList"></app-stepper>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12 md6 mb-3>
          <v-autocomplete
            v-model="selectedAgency" 
            @change="changedData" 
            @keyup.enter="searchAgencies($event)"
            :items="unselectedAgnecies" 
            :multiple="false"
            item-text="name"
            item-value="id"
            label="Search by Agency"
            :rules="[rules.toRule]"
            id="recipientSearch"
            hide-no-data
            hint="Type atleast 3 characters to search"
            class="required pr-4 pl-4">
            <v-icon slot="append" @click="searchAgencies($event)"> search </v-icon>
          </v-autocomplete>
          <v-layout v-if="searchAgencyString.length > 2 && !unselectedAgnecies.length">
            <v-flex class="agencyItem pb-2" xs12>
              <span>No records found</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-2 text-xs-right">
          <div class="d-inline-flex" v-if="selectedAgency">
            <v-btn class="pf-btn pf-btn-cancel" to="/agencies">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="saveRequest">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Request</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <app-modal :active="isSelectCard" v-if="isSelectCard" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeSelectCard">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add new agency</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <v-form ref="checkoutForm">
              <!-- Show the initial and recurring amount -->
              <v-layout wrap class="ma-3">
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Initial Amount: </span>
                  <span class="pf-font-16">{{ payment && payment.amount ? formatPrice(payment.amount) : 'Free' }}</span>
                </v-flex>
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Recurring Amount: </span>
                  <span class="pf-font-16">{{ payment && payment.recurring_amount ? formatPrice(payment.recurring_amount) : 'Free' }}</span>
                </v-flex>
                <v-flex xs4>
                  <span class="pf-font-16 font-weight-bold">Payment Interval: </span>
                  <span class="pf-font-16">{{ payment && payment.recurring_billing_period ? (`${payment.recurring_billing_period} (${payment.recurring_billing_type})`) : 'Free' }}</span>
                </v-flex>
              </v-layout>
              <hr class="my-3" />
              <v-layout wrap>
                <v-flex sm6>
                  <v-layout class="flex-column pl-3">
                    <span class="pf-font-16 font-weight-bold">Choose from your cards</span>
                    <v-flex class="flex-column listCard">
                      <v-radio-group v-model="selectedCardId" return-object>
                        <v-layout v-for="(card, i) in cards" :key="i">
                          <v-flex class="flex-center">
                            <v-radio
                              :value="card.id"
                              class="flex-center"
                              @change="resetCard"
                            >
                              <template v-slot:label>
                                <div class="flex-center">
                                  <div class="pf-card-icon" :style="`background-image:url(/static/cards/${card.icon});`"></div>
                                  #### #### #### {{ card.number.substr(card.number.length - 4) }}
                                </div>
                              </template>
                            </v-radio>
                          </v-flex>
                        </v-layout>
                        <p v-if="!cards.length">No saved cards found.</p>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex sm6>
                  <span class="pf-font-16 font-weight-bold">Use a new card</span>
                  <v-layout wrap>
                    <!-- Content -->
                    <v-flex xs12>
                      <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                        <template v-slot:prepend>
                          <v-fade-transition leave-absolute>
                            <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                          </v-fade-transition>
                        </template>
                      </v-text-field>
                      <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field v-model.trim="newCard.cvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            class="pf-btn-text-white pf-bg-pink"
            @click="closeSelectCard"
            >
            Cancel
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="checkout"
            >
              Checkout
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store */
import { getCollection, update, create, getCardType, request, formatPrice } from '../helpers/helpers';
import appStepper from '../components/appStepper';
import AppModal from '../components/AppModal';
import swal from 'sweetalert2';
import { mask } from 'vue-the-mask';
export default {
  components: {
    appStepper,
    'app-modal': AppModal,
  },
  directives: { mask },
  data: (vm) => ({
    entity: 'Request',
    isLoading: false,
    selectedAgencies: [],
    selectedAgency: null,
    unselectedAgnecies: [],
    searchedAgencies: [],
    searchAgencyString: '',
    rules: {
      toRule: (v) => !!v || 'Please search the agency and select',
      card: {
        // number: [v => !!v || 'Card number is required'],
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      }
    },
    formatPrice, 
    stepperList: [
      {
        name: 'Search',
        description: 'Search by agency name.',
        image: '/static/stepper/search.jpg'
      },
      {
        name: 'Select Agency',
        description: 'Select the agency you wish to be a part of.',
        image: '/static/stepper/agency.jpg'
      },
      {
        name: 'Complete Payment & Send Request',
        description: 'Click on the "Request" button for payment if any and then agency approval.',
        image: '/static/stepper/send.jpg'
      },
      {
        name: 'Status',
        description: 'Status regarding your request will be listed in your "My Agencies" page.',
        image: '/static/stepper/status.jpg'
      }
    ],
    newCardNumber: '',
    newCardNumberMask: '',
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: '',
      cvv: ''
    },
    selectedCardId: null,
    isSelectCard: false,
    cards: [],
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
    payment: null
  }),
  computed: {
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      },
    },
    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
    // MyAgencies: {
    //   set (value) {
    //     store.commit('setMyAgencies', value);
    //   },
    //   get () {
    //     return store.state.MyAgencies;
    //   }
    // },
  },
  async created () {
    // await this.myAgenciesIntialize();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async searchAgencies (e) {
      this.searchedAgencies = [];
      this.unselectedAgnecies = [];
      this.searchAgencyString = e.target.value ? e.target.value : document.querySelector('input[id="recipientSearch"]').value;
      if ((this.searchAgencyString.length > 2)) {
        let where = { is_admin: false };
        if (!where.$or) {
          where.$or = [{
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          }];
        } else {
          where.$or.push({
            'name': { $regex: `.*` + this.searchAgencyString + `.*`, $options: 'i' }
          });
        }
       
        let attributes = 'name,createdAt,account,_id,is_additional_display_fee,additional_display_fee';
        let populate = [{ path: 'human' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.searchedAgencies = data;
            this.getUnselectAgenciesList();
          } else {
            this.searchedAgencies = [];
          }
        }
      }
    },
    async getUnselectAgenciesList () {
      this.unselectedAgnecies = this.searchedAgencies.filter(agency => this.Account.agency.findIndex(x => x.agency === agency.id) === -1);
    },
    // async myAgenciesIntialize () {
    //   if (!this.MyAgencies.length && this.Account.agency && this.Account.agency.length) {
    //     let where = { 'account.account': this.Account.id };
    //     let populate = [{ path: 'human' }];
    //     let { error, data } = await getCollection('Agency', true, 0, populate, where);
    //     if (error) {
    //       console.log(error);
    //     } else {
    //       if (data.length > 0) {
    //         this.MyAgencies = data;
    //       }
    //     }
    //   }
    // },

    changedData () {
      this.selectedData = true;
    },
    newCardChange (newValue) {
      this.selectedCardId = null;
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    setCards () {
      this.cards = this.PaymentMode.map(mode => {
        mode.card.icon = 'credit-card.ico';
        mode.card.id = mode.id;
        return mode.card;
      });
    },
    async fetchPaymentModes () {
      if (!this.PaymentMode.length) {
        let where = { account: this.Account.id };
        let { error, data } = await getCollection('PaymentMode', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.PaymentMode = data;
            /* Set the local card variable */
            this.setCards();
          }
        }
      } else {
        this.setCards();
      }
    },

    setCardIcons () {
      this.cards = this.cards.map((x) => {
        let index = this.cardIcons.findIndex(y => y.type === x.type);
        if (x.type && index > -1) {
          x.icon = this.cardIcons[index].icon;
        }
        return x;
      });
    },

    closeSelectCard () {
      this.isSelectCard = false;
      this.newCardNumber = '';
      this.newCardNumberMask = '';
      this.resetCard();
    },
    resetCard () {
      this.newCard = {
        name: '',
        number: '',
        expiry: '',
        icon: 'credit-card.ico',
        type: '',
        cvv: ''
      };
      this.newCardNumber = '';
      this.newCardNumberMask = '';
    },

    async doPaymentForAdditionalDisplay (paymentRequiredAgencies) {
      // List the saved cards for the family
      await this.fetchPaymentModes();
      /* Set the card icon based on card type */
      this.setCardIcons();

      this.isSelectCard = true;
    },

    async checkout () {
      if (!this.selectedCardId && !(this.newCard.number || this.newCard.name || this.newCard.expiry || this.newCard.cvv)) {
        swal.fire({
          type: 'error',
          title: 'Please add or select a card',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      let cardFormValid = true;
      if (!this.selectedCardId) {
        cardFormValid = this.$refs.checkoutForm.validate();
      }
      if ((cardFormValid || this.selectedCardId) && this.payment) {
        let payload = {
          account: this.Account.id,
          agency: this.selectedAgency,
          ...this.payment,
          basic_details: {
            parent1: {
              first_name: this.Account.human[0].first_name,
              last_name: this.Account.human[0].first_name || ''
            },
            username: this.Account.nickname,
            membership: this.Account.membership,
            phone: this.Account.contactInfo.phone,
            email: this.Account.contactInfo.email
          },
          address: {
            line_1: this.Account.contactInfo.line_1,
            line_2: this.Account.contactInfo.line_2,
            city: this.Account.contactInfo.city,
            state: this.Account.contactInfo.state && this.Account.contactInfo.state.name ? this.Account.contactInfo.state.name : '',
            zip: this.Account.contactInfo.zip,
            country: this.Account.contactInfo.country && this.Account.contactInfo.country.name ? this.Account.contactInfo.country.name : ''
          },
        };
        if (this.selectedCardId) {
          payload.payment_mode = this.selectedCardId;
        } else if (this.newCard) {
          payload.card = JSON.parse(JSON.stringify(this.newCard));
          delete payload.card.icon;
          delete payload.card.type;
          delete payload.card.name;
          /* format the card details */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.cvv = payload.card.cvv.replace(/ /g, '');

        } else {
          swal.fire({
            type: 'error',
            text: `You have to add or select the card to checkout`,
            showConfirmButton: true,
            timer: 2500
          });
          return;
        }

        window.getApp.$emit('LoadingText', 'Please wait.. We\'re processing your payment and setting up the subscription.');
        let { error, data } = await request('Payment/AddNewAgency', 'POST', payload);
        if (error) {
          console.log(error);
          swal.fire({
            type: 'warning',
            title: 'Error',
            text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
            showConfirmButton: true,
            timer: 2500
          });
        } else if (data) {
          this.resetCard();
          this.selectedCardId = null;
          this.isSelectCard = false;
          this.payment = null;
          this.processRequests();
        } else {
          swal.fire({
            type: 'error',
            title: 'Failed to process the request, please try again',
            showConfirmButton: false,
            timer: 2500
          });
        }
        window.getApp.$emit('LoadingText', 'Loading');
      }
    },

    async saveRequest () {
      // Check if any selected agency requires payment
      let paymentRequiredAgencies = this.unselectedAgnecies.filter(agency => this.selectedAgency === agency.id && agency.is_additional_display_fee);
      this.payment = paymentRequiredAgencies.length ? paymentRequiredAgencies[0].additional_display_fee : null;
      if (this.payment && this.payment.amount) {
        const self = this;
        swal.fire({
          type: 'warning',
          title: 'Payment Required',
          text: 'You have selected an agency that requires payment. Please complete the payment to continue.',
          showConfirmButton: true,
          onClose: () => {
            self.doPaymentForAdditionalDisplay(paymentRequiredAgencies);
          }
        });
        return;
      }
      this.processRequests();
    },
    async processRequests () {
      // for (let i = 0; i < this.selectedAgencies.length; i++) {
      let postData = {
        status: 'Pending',
        agency: this.selectedAgency,
        updateAt: new Date().toISOString()
      };
      this.Account.agency.push(postData);
      this.Account.updated_from = 'default';
      let { error, data, status } = await update('Account', this.Account, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
      if (error) {
        console.log('error', error);
      } else {
        this.Account = data;
        // timeline update on agency request
        let agency = await this.unselectedAgnecies.find(agency => agency.id === this.selectedAgency);
        let TimelineObj = {
          text: `Request sent to the agency '${agency.name}'`,
          title: 'Request Sent',
          agency: agency.id
        };
        if (session.getSession().adminUser) {
          TimelineObj.account = session.getSession().user.human.account.id;
        }
        let { TimelineError, timelineData } = await create('Timeline', TimelineObj);
        if (TimelineError) {
          this.selectedData = true;
          console.log('error', TimelineError);
        }
        this.loading = false;
        // if (this.selectedAgencies.length === i + 1) {
        swal.fire({
          type: 'success',
          title: 'Your request was sent to the agency',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.$router.push({ path: '/agencies' });
          }
        });
        // }
      }
      // }
    }
  }
};
</script>
<style scoped>

.instructions {
    min-height: 180px;
    background-color: #019d8c;
    margin-top: 10px;
    padding:20px;
    text-align: center;
    color: #FFF;
 }
 .agencyItem {
  border-bottom: 1px solid #ccc;
 }
</style>



// WEBPACK FOOTER //
// src/pages/AgencyAdd.vue